export const createInstagramPostReferrer = (postId: number) => {
    return `instagram-post-${postId}`;
};
